<template>
  <yxt-drawer
    :title="$t('pc_biz_place_title'/* 选择场地 */)"
    direction="rtl"
    :before-close="handleClose"
    :visible.sync="visible"
    size="960px"
  >
    <!--树形控件-->
    <yxt-container class="yxtbiz-place-selector">
      <div class="yxtbiz-place-selector__aside" ref="tree" v-loading="loading">
        <yxt-tree
          :data="categorieList"
          wrap-width="200"
          node-key="id"
          :expand-on-click-node="false"
          :default-expanded-keys="['0']"
          @node-click="handleTreeClick"
        ></yxt-tree>
      </div>
      <placeTable 
        ref="refPlaceTable"
        :districtId="districtId"
        :address="address"
        :cityId="cityId"
        @complete="complete"
        :provinceId="provinceId"/>
    </yxt-container>
    <span
      slot="footer"
      class="dialog-footer">
      <yxt-button
        plain
        @click="handleClose"
      >{{$t('pc_biz_core_btn_cancel'/* 取消 */)}}</yxt-button>
    </span>    
  </yxt-drawer>
</template>

<script>

import { getCategories } from './service';
import PlaceTable from './components/placeTable';
import resizeTable from '../mixins/resizeTable';
import {
  Container,
  Drawer,
  Tree
} from 'yxt-pc';

export default {
  name: 'YxtbizPlaceSelector',
  components: {
    PlaceTable,
    YxtContainer: Container,
    YxtDrawer: Drawer,
    YxtTree: Tree
  },
  mixins: [resizeTable],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    address: String,
    startTime: String,
    endTime: String,
    provinceId: String || Number,
    provinceName: String,
    cityId: String || Number,
    cityName: String,
    districtId: String || Number,
    districtName: String
  },
  data() {
    return {
      loading: true,
      categorieList: [],
      searchInput: ''
    };
  },
  mounted() {
    if (this.provinceName) {
      this.address = `${this.provinceName}${this.cityName || ''}${this.districtName || ''}`;
    }
    getCategories().then(res => {
      if (res && res.datas) {
        this.categorieList = [{
          children: res.datas,
          id: '0',
          label: this.$t('pc_biz_place_lbl_categorie'/* 场地分类 */)
        }];
      } else {
        this.categorieList = [{
          id: '0',
          label: this.$t('pc_biz_place_lbl_categorie'/* 场地分类 */)
        }];
      }
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  },
  watch: {
    address(val) {
      this.searchInput = val;
      this.$refs.refPlaceTable.refreshTable({currentPage: 1});
    }
  },
  methods: {
    /* 树形控件 */
    handleTreeClick(data) {
      this.$refs.refPlaceTable.refreshTable({ categoryId: data.id, currentPage: 1});
    },
    handleClose() {
      this.$confirm(this.$t('pc_biz_core_msg_confirmcancletip'/* 当前操作尚未保存，是否确认取消？ */), this.$t('pc_biz_core_msg_cancel'/* 确认取消？ */), { type: 'warning' })
        .then(() => {
          this.$emit('complete');
          this.$emit('update:visible', false);
        }).catch(() => { });
    },
    complete(data) {
      this.$emit('complete', data);
      this.$emit('update:visible', false);
    }
  }
};
</script>
